// extracted by mini-css-extract-plugin
export default {"page":"Faq_page__Rlag9"};